__turbopack_context__.v({
  "accordion-plus-minus": "AcfAccordion-module-scss-module__jF4UZq__accordion-plus-minus",
});
